import { ref } from '@vue/composition-api'
import nominationsApi from '@/services/api/nominations'

export default function useNominationsBulkEmail(draftId) {
  const sendTypes = ref([])
  const recipients = ref([])
  const sending = ref(false)
  const optionsLoading = ref(false)

  async function fetchOptions() {
    optionsLoading.value = true
    try {
      const res = await nominationsApi.bulkMessageOptions(draftId)
      const data = res.data.data != null ? res.data.data : {}
      sendTypes.value = data.sendTypes != null ? data.sendTypes : []
      recipients.value = data.recipients != null ? data.recipients : []
    } catch (_) { /* handled by http interceptor */ }
    optionsLoading.value = false
  }

  async function send(data) {
    sending.value = true
    try {
      const res = await nominationsApi.bulkMessage(draftId, data)
      return res.data
    } catch (_) {
      return null
    } finally {
      sending.value = false
    }
  }

  return {
    sendTypes,
    recipients,
    sending,
    optionsLoading,
    fetchOptions,
    send
  }
}



// WEBPACK FOOTER //
// ./src/composables/nominations/useNominationsBulkEmail.js